import { usePathname } from 'next/navigation';

import type { ListProduct } from '@/queries/Products';

const ProductSchema = ({
  product,
}: {
  readonly product: ListProduct | undefined;
}) => {
  const path = usePathname();
  const price = product?.price;

  const logoStructuredJSON = JSON.stringify({
    '@context': 'https://schema.org/',
    '@type': 'Organization',
    name: 'OURA',
    url: 'https://ouraring.com/',
    logo: 'https://ouraring.com/blog/wp-content/uploads/2021/12/7B24ADCF-7925-4513-A32B-B81476285567_1_105_c.jpeg',
  });

  const structuredJSON = JSON.stringify({
    '@context': 'https://schema.org/',
    '@type': 'Product',
    name: product?.title,
    image: product?.images?.[0]?.originalSrc,
    offers: {
      '@type': 'Offer',
      priceCurrency: price?.currencyCode,
      price: String(price?.amount),
      availability: 'https://schema.org/InStock',
      url: `https://ouraring.com${path}`,
      priceValidUntil: '',
    },
    description:
      'Sleek, comfortable, accurate. Oura Smart Ring fits seamlessly into your life, all night and all day.',
    brand: 'OURA Ring',
  });

  return (
    <>
      <script
        data-cy="logo-script"
        id="logo-script"
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: logoStructuredJSON }}
      />
      <script
        data-cy="product-script"
        id="structured-homepage-schema"
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: structuredJSON }}
      />
    </>
  );
};

export default ProductSchema;
